import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useScrollFadeIn } from 'hooks/useScrollFadeIn';

import ConsultImage from 'resources/videoLanding/consult.png';
import ProductionImage from 'resources/videoLanding/production.png';
import PMImage from 'resources/videoLanding/pm.png';
import MobileConsultImage from 'resources/videoLanding/consult_m.png';
import MobileProductionImage from 'resources/videoLanding/production_m.png';
import MobilePMImage from 'resources/videoLanding/pm_m.png';

const VideoWhyBriphy = () => {

  const [mode, setMode] = useState('pc');

  const consultAnime = useScrollFadeIn({threshold: 0.1, delay: '0.1', direction: 'bottomUp'});
  const pmAnime = useScrollFadeIn({threshold: 0.1, delay: '0.3', direction: 'bottomUp'});
  const productionAnime = useScrollFadeIn({threshold: 0.1, delay: '0.3', direction: 'bottomUp'});
  const mobileConsultAnime = useScrollFadeIn({threshold: 0.1, delay: '0.1', direction: 'bottomUp'});
  const mobileProductionAnime = useScrollFadeIn({threshold: 0.1, delay: '0.3', direction: 'bottomUp'});
  const mobilePmAnime = useScrollFadeIn({threshold: 0.1, delay: '0.3', direction: 'bottomUp'});

  // PC/Mobile 화면 Resize
  const handleResize = () => {
    setMode(window.innerWidth);
    if(window.innerWidth < 768) {
      setMode('mobile');
    } else {
      setMode('pc');
    }
  };

  /**
   * 웹/모바일 스크롤 위치에 따라 Why BRIPHY, Clients 배경색을 바꿔주는 함수 
   * @param {number} height 스크롤 높이 값
   */
  const changeCSS = (height) => {
    let whyContainer = document.querySelector('.why');
    let clientsContainer = document.querySelector('.client');
    let textElems = document.querySelectorAll('.txt');
    let subTextElems = document.querySelectorAll('.subTxt');

    if (window.scrollY >= height) {
      if (whyContainer) {
        whyContainer.style.backgroundColor = '#FFFFFF';
        whyContainer.style.transitionDuration = '0.3s';
        whyContainer.style.transitionTimingFunction = 'ease-in-out';
      }
      if (clientsContainer) {
        clientsContainer.style.backgroundColor = '#FFFFFF';
        clientsContainer.style.transitionDuration = '0.3s';
        clientsContainer.style.transitionTimingFunction = 'ease-in-out';
      }

      textElems?.forEach((item) => {
        item.style.color = '#2C2C2C';
      });
      
      subTextElems?.forEach((item) => {
        item.style.color = '#4B4B4B';
      });
      
    } else {
      if (whyContainer) {
        whyContainer.style.backgroundColor = '#000000';
        whyContainer.style.transitionDuration = '0.3s';
        whyContainer.style.transitionTimingFunction = 'ease-in-out';
      }
      if (clientsContainer) {
        clientsContainer.style.backgroundColor = '#000000';
        clientsContainer.style.transitionDuration = '0.3s';
        clientsContainer.style.transitionTimingFunction = 'ease-in-out';
      }      

      textElems?.forEach((item) => {
        item.style.color = '#FFFFFF';
      });

      subTextElems?.forEach((item) => {
        item.style.color = '#ABABAC';
      });
    }
  }

  // 스크롤 함수
  const onScroll = (e) => {
    if (mode === 'pc') {
      changeCSS(1850);
    } else if (mode === 'mobile') {
      changeCSS(1450);
    }
  }

  useEffect(()=> {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    window.addEventListener('scroll', (e) => {
      onScroll(e);
    });
    return () =>window.removeEventListener('scroll', onScroll);
  }, [mode]);

  return (
    <Container className='why'>
      <WhyContainer>
        <Title className='txt'>Why BRIPHY?</Title>
        <Description className='subTxt'>제작사를 컨트롤할 수 있는 전문가의 유무는 프로젝트 성공을 좌우합니다<br/>
        브리피가 고객의 촬영팀이 되어 성공적인 비주얼 구현 과정에 함께합니다</Description>
        <MobileDescription className='subTxt'>제작사를 컨트롤할 수 있는 전문가의 유무는 프로젝트 성공을 좌우합니다. 브리피가 고객의 촬영팀이 되어 성공적인 비주얼 구현 과정에 함께합니다</MobileDescription>
        <ItemContainer>
          <div>
            <ItemWrapper className='consult' {...consultAnime}>
              <WhyImage><img src={ConsultImage} /></WhyImage>
              <SubTitle className='txt'>전문 컨설팅</SubTitle>
              <Desc className='subTxt'>10년 이상 경력의 전문가들이 직접 상담을 진행하며 최적의 견적과<br/>제작 방향을 제안합니다</Desc>
            </ItemWrapper>
            <ItemWrapper className='pm' {...pmAnime}>
              <WhyImage><img src={PMImage} /></WhyImage>
              <SubTitle className='txt'>프로젝트 매니지먼트</SubTitle>
              <Desc className='subTxt'>기획 단계부터 최종 결과물 납품까지 고객의 촬영팀이 되어 프로젝트 전 과정을 함께 고민하고 진행합니다.</Desc>
            </ItemWrapper>
          </div>
          <div>
            <ItemWrapper className='production' {...productionAnime}>
              <WhyImage><img src={ProductionImage} /></WhyImage>
              <SubTitle className='txt'>검증된 제작사</SubTitle>
              <Desc className='subTxt'>클라이언트의 요구 사항과 제작 조건에 맞춰 선별된<br/>최적의 제작사를 연결합니다</Desc>
            </ItemWrapper>
          </div>
        </ItemContainer>
        <MobileItemContainer>
          <ItemWrapper {...mobileConsultAnime}>
            <WhyImage><img src={MobileConsultImage} /></WhyImage>
            <SubTitle className='txt'>전문 컨설팅</SubTitle>
              <Desc className='subTxt'>10년 이상 경력의 전문가들이 직접 상담을 진행하며 최적의 견적과 제작 방향을 제안합니다</Desc>
          </ItemWrapper>
          <ItemWrapper {...mobilePmAnime}>
            <WhyImage><img src={MobileProductionImage} /></WhyImage>
            <SubTitle className='txt'>검증된 제작사</SubTitle>
              <Desc className='subTxt'>클라이언트의 요구 사항과 제작 조건에 맞춰 선별된 최적의 제작사를 연결합니다</Desc>
          </ItemWrapper>
          <LastItemWrapper {...mobileProductionAnime}>
            <WhyImage><img src={MobilePMImage} /></WhyImage>
            <SubTitle className='txt'>프로젝트 매니지먼트</SubTitle>
              <Desc className='subTxt'>기획 단계부터 최종 결과물 납품까지 고객의 촬영팀이 되어 프로젝트 전 과정을 함께 고민하고 진행합니다.</Desc>
          </LastItemWrapper>
        </MobileItemContainer>
      </WhyContainer>
    </Container>
  )
}

export default VideoWhyBriphy;

const Container = styled.div`
  display: flex;
  width: 100%;  
  margin: 0 auto;
  background: #000000;
`

const WhyContainer = styled.div`
  width: 1088px;
  // height: 1156px;
  margin: 0 auto;
  padding: 180px 0;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 60px 16px 57px;
  }
`

const Title = styled.div`
  text-align: center;
  color: #FFFFFF;
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;

  @media ${({theme}) => theme.device.mobile} {
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
  }
`

const Description = styled.div`
  margin-top: 8px;
  margin-bottom: 80px;
  text-align: center;
  font-size: 18px;
  font-weight: 200;
  line-height: 24px; /* 133.333% */
  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
`

const MobileDescription = styled.div`
  display: none;  
  @media ${({theme}) => theme.device.mobile} {
    text-align: center;
    font-size: 13px;
    font-weight: 200;
    line-height: 16px;
    margin: 5px 0 25px;
    display: block;
    padding: 0 5px;
  }
`
const ItemContainer = styled.div`
  display: flex;
  width: 928px;
  height: 972px;
  margin: 0 auto;
  
  .consult {
    width: 500px;
    // margin-top: 160px;
  }
  
  .production {
    margin-left: 58px;
    margin-top: 160px;
  }
  
  .pm {
    width: 330px;
    margin-left: 134px;
    margin-top: 204px;
  }

  @media ${({theme}) => theme.device.mobile} {
    display: none;
  }
`
  
const MobileItemContainer = styled.div`
  display: none;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`

const ItemWrapper = styled.div`

  @media ${({theme}) => theme.device.mobile} {
    margin-bottom: 70px;
  }
`

const LastItemWrapper = styled.div`

  @media ${({theme}) => theme.device.mobile} {
    margin-bottom: 0px;
  }
`

const WhyImage = styled.div`
  margin-bottom: 19px;
  text-align: right;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    margin-bottom: 15px;
    text-align: center;

    img {
      width: 100%;
    }
  }
`

const SubTitle = styled.div`
  margin-bottom: 6px;
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;

  @media ${({theme}) => theme.device.mobile} {
    margin-bottom: 5px;
    font-size: 20px;
    line-height: 24px;
  }
`

const Desc = styled.div`
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  
  @media ${({theme}) => theme.device.mobile} {
    font-size: 14px;
    line-height: 18px;
  }
`